import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '../../store/hooks'
import { updatePassword } from '../../store/authSlice'

function parseHashError(): { code: string; description: string } | null {
  const hash = window.location.hash.replace(/^#/, '')
  if (!hash) return null
  const params = new URLSearchParams(hash)
  const code = params.get('error_code') ?? params.get('error')
  if (!code) return null
  const description = params.get('error_description')?.replace(/\+/g, ' ') ?? ''
  return { code, description }
}

export default function SetNewPasswordScreen() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [linkError, setLinkError] = useState<{ code: string; description: string } | null>(null)

  useEffect(() => {
    setLinkError(parseHashError())
  }, [])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    if (password.length < 6) { setError('Password must be at least 6 characters.'); return }
    if (password !== confirm) { setError('Passwords do not match.'); return }

    const result = await dispatch(updatePassword(password))
    if (updatePassword.fulfilled.match(result)) {
      navigate('/')
    } else {
      setError(result.payload as string)
    }
  }

  if (linkError) {
    const expired = linkError.code === 'otp_expired'
    return (
      <div className="onboard-wrap" data-testid="set-new-password-link-error">
        <div className="onboard-box">
          <h2>{expired ? 'This link has expired' : 'This link is invalid'}</h2>
          <p>
            {expired
              ? 'Password reset links expire after a short time. Request a new one to continue.'
              : linkError.description || 'The reset link could not be used. Please request a new one.'}
          </p>
          <button
            className="btn btn-primary gate-btn"
            onClick={() => navigate('/reset-password')}
            data-testid="request-new-reset-link-btn"
          >
            Request a new reset link
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="onboard-wrap" data-testid="set-new-password-screen">
      <div className="onboard-box">
        <h2>Set New Password</h2>
        <form onSubmit={handleSubmit} data-testid="set-password-form">
          <input
            type="password"
            className="gate-input"
            placeholder="New password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="new-password-input"
          />
          <input
            type="password"
            className="gate-input"
            placeholder="Confirm new password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            data-testid="confirm-new-password-input"
          />
          {error && <div className="gate-err" data-testid="set-password-error">{error}</div>}
          <button
            type="submit"
            className="btn btn-primary gate-btn"
            data-testid="set-password-submit-btn"
          >
            Update password
          </button>
        </form>
      </div>
    </div>
  )
}
